import ApiClient from '@/utils/api-client'
export default {
  getWechatAuth(): any {
    return ApiClient.post(`/wechat/js`)
  },
}
